// Default task types (task 1.2, D-028), editable from the Settings page.
// Labels are configuration data, like the deal stages: they stay in Italian
// whatever the interface language.
export const tenaxTaskTypes = [
  { value: "call", label: "Chiamata" },
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "instagram_dm", label: "Messaggio Instagram" },
  { value: "meeting", label: "Riunione" },
  { value: "proposal", label: "Proposta" },
  { value: "follow_up", label: "Ricontattare" },
  { value: "shipping", label: "Spedizione" },
  { value: "other", label: "Altro" },
];

export const DEFAULT_TASK_TYPE = "other";
